/* eslint-disable react/display-name */
import { Button } from 'antd'
import { REGEX_FORMATS } from 'common/constants'
import processString from 'react-process-string'
import urlRegexSafe from 'url-regex-safe'

export const renderComment = (textInput: string) => {
  return processString([
    {
      regex: REGEX_FORMATS.MENTION_USER,
      fn: (key: number, result: string) => {
        return (
          <Button type="link" style={{ padding: 0, height: 'auto' }} key={key}>
            {result[1]}
          </Button>
        )
      },
    },
    {
      // `strict` avoids the bundled `tlds` list: webpack production builds prune it to [], which truncates matches
      regex: urlRegexSafe({ strict: true }),
      fn: (key: number, result: string) => {
        return (
          <a target="_blank" rel="noopener noreferrer" key={key} href={result[0]}>
            {result[0]}
          </a>
        )
      },
    },
    {
      regex: REGEX_FORMATS.BREAK_LINE,
      fn: (key: number) => {
        return <br key={key} />
      },
    },
  ])(textInput)
}
